export const errorV2Mappings = {
  'FLEET_TASK.DELIVERY_ORDER_INVALID_STATUS' : 'routeOptimization.alert.deliveryOrderInvalidStatus'
}